import React, {Component} from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import BillingMethodCostLabel from "./costlabel.component.jsx"
import BillingMethodPriceLabel from "./pricelabel.component.jsx"
import {MATRIX_ITEM_UPDATE_OPTION} from "../../state/product/Types";

class BillingMethodPricingBracketLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            billingMethods: this.props.billingMethods || [],
            pricingBrackets: this.props.pricingBrackets || [],
            pricingStrategy: this.props.pricingStrategy || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            billingMethods: nextProps.billingMethods || [],
            pricingBrackets: nextProps.pricingBrackets || [],
            pricingStrategy: nextProps.pricingStrategy || '',
        })
    }

    componentDidMount() {}

    renderAmounts(field) {

        let bracketCustomText = <FormattedMessage
            id="product.form.edit.custom_bracket_empty_label"
            defaultMessage="Not defined"
        />
        if (this.state.pricingBrackets.length > 0) {
            bracketCustomText = <FormattedMessage
                id="product.form.edit.custom_bracket_from_to_label"
                defaultMessage="from {fromValue} to {toValue}"
                values={{
                    fromValue: <FormattedNumber
                        style="currency"
                        currency= {AppContext.getCurrency()}
                        value={Math.min.apply(Math, this.state.pricingBrackets.map(i => i[field]))}
                    />,
                    toValue: <FormattedNumber
                        style="currency"
                        currency= {AppContext.getCurrency()}
                        value={Math.max.apply(Math, this.state.pricingBrackets.map(i => i[field]))}
                    />,
                }}
            />
        }
        return bracketCustomText
    }

    renderRow(key, method, type) {
        let field = ""
        if (method === "one-time") {
            field = type
        } else {
            if (type === "price") {
                field = method + "Price"
            } else {
                field = method + "Cost"
            }
        }
        let label = <BillingMethodCostLabel
            billingMethod={method}
            pricingStrategy={this.state.pricingStrategy}
        />
        if (type === "price") {
            label = <BillingMethodPriceLabel
                billingMethod={method}
                pricingStrategy={this.state.pricingStrategy}
            />
        }

        if(this.props.hideLabel) {
            return this.renderAmounts(field)
        }

        return (
            <div className="row pt-2" key={key}>
                <div className="col-6">
                    <strong>
                        {label}:
                    </strong>
                </div>
                <div className="col-6 p-0">
                    {this.renderAmounts(field)}
                </div>
            </div>
        )
    }
    render() {
        const rows = []
        for (let index in this.state.billingMethods) {
            const method = this.state.billingMethods[index]
            switch (this.props.labelType) {
                case  MATRIX_ITEM_UPDATE_OPTION.PRICE:
                    rows.push(this.renderRow(rows.length, method, "price"))
                    break
                case MATRIX_ITEM_UPDATE_OPTION.COST:
                    rows.push(this.renderRow(rows.length, method, "cost"))
                    break
                default:
                    rows.push(this.renderRow(rows.length, method, "price"))
                    rows.push(this.renderRow(rows.length, method, "cost"))
            }
        }
        return rows
    }
}

export default BillingMethodPricingBracketLabel





// WEBPACK FOOTER //
// ./src/product/billing-method/pricingbracketslabel.component.jsx